//cn文件
module.exports = {
  header1: "首页",
  header2: "关于我们",
  header2_1: "我们是谁",
  header2_2: "为什么选择我们",
  header3: "交易平台",
  header4: "MT5指南",
  header5: "联系我们",
  header6: "开设真实账号",
  header7: "登录",
  header8: "注册",
  footer1: "加入交易者行列",
  footer2: "免费试用",
  footer3: "立即开始交易",
  footer4: "关注我们",
  footer5: "版权所有",
  footer6: "保留所有权利",
  home1: "交易产品",
  home2: "入金免手续费",
  home3: "低至零点差",
  home4: "随处皆可进行交易",
  home5: "超过200种可交易产品",
  home6: "9种时间段选项",
  home7: "可在Pc和Mobile 上登录账户",
  home8: "专业的分析工具",
  home9: "下载PC版MT5",
  home10: "网络交易者",
  home11: "无需下载或安装",
  home12: "在任何网络浏览器上访问您的帐户",
  home13: "与MT4一样功能强大",
  home14: "随时随地连接市场进行交易",
  home15: "开启网页版mt5",
  home16: "帮助您做出",
  home17: "最佳的交易决策",
  home18: "使用这些交易工具来帮助您做出最明智的决定",
  home19: "智能交易系统",
  home20: "通过专业的EA获得交易优势",
  home21: "交易信号",
  home22: "如灯塔般指引你赢向成功。",
  home23: "经济日历",
  home24: "掌握最新的市场趋势",
  home25: "Protrader工具",
  home26: "获取更多交易机会",
  home27: "市场消息",
  home28: "精选市场观点",
  home29: "分析师观点",
  home30: "专业版经济日历",
  home31: "开设交易账号并至少入金1000美元",
  home32: "即可使用全套专业交易工具",
  home33: "即刻入金",
  home34: "开设真实账户",
  home35: "完美体验",
  home36: "极速执行交易订单",
  home37:
    "“什么是交易者选择外汇经纪人时的关键要素?”–这是我们在建立{platform}时不断问自己的问题。我们认为，这些要素是定义我们的价值，使我们能够满足客户需求并持续提供卓越可靠服务的核心。",
  home38: "5分钟极速开户",
  home39: "200种以上可交易商品组合",
  home40: "功能完善的账户管理系统",
  home41: "绝佳的市场流动性",
  home42: "了解更多",
  home43: "合规监管",
  home44: "提供最佳安全保障",
  home45:
    "{platform}非常重视监管和安全性。我们为所有客户提供透明、安全的外汇交易环境。",
  home46: "全球办事处",
  home47: "多国监管",
  home48: "世界顶尖金融机构合作",
  home49: "资金保险",
  home50: "监管",
  home51: "赔偿",
  home52: "保险",
  home53: "入金方式",
  home54: "市场流动性合作伙伴",
  home55:
    "{platform} 和14家以上的世界顶尖流动性报价商合作，充足的流通性能够为您提供市场上最优异的交易报价",
  home56: "外汇交易",
  home57: "利用全球经济动荡局势，连接世界上流动性最强的金融市场",
  home58: "立即开始交易",
  home59: "大宗商品交易",
  home59_1: "大宗交易",
  home60: "依据主要市场交易周期选择黄金、白银、原油或其它软性商品",
  home61: "指数交易",
  home61_1: "指数",
  home62:
    "透过全球大型股票指数如SP500、DJ30、FRA40和DAX30等指数的波动，进行交易",
  home63: "美国/香港 股票交易",
  home64: "掌握全球大型公司动向，以差价合约交易美国和香港的股票",
  home65: "差价合约",
  home66: "全球业务",
  home67: "为客户提供一流、稳定的服务，是我们的荣幸",
  home68: "网页版交易",
  who0: "谁是{platform}",
  who1: "加入最具创新的经纪人",
  who2:
    "{platform}在全球金融市场上拥有10多年经验和专业知识，致力于提供简单透明化的市场准入并帮助的客户实现财务目标。",
  who3:
    "{platform}于2010年在英国成立，始终秉持“随时随地  畅享交易”的理念，运用先进的技术服务，为客户在外汇市场中提供卓越的交易经验，其中包括原始点差、极速执行准确交易的ECN帐户以及强大的客户端管理系统等。",
  who4: "选择可信任的外汇经纪人",
  who5:
    "{platform1}一直致力于为客户提供卓越的交易环境，且始终坚持抱着超越全球金融监管机构的期望。在这个行业中我们了解到，交易者渴望找到一个可以信赖的平台。{platform2}在多个机构监管的监管下，我们积累超过10,000个来自世界各地活跃的客户交易账户，他们皆倚赖{platform3}以确保其资金的安全性。",
  who6: "主要监管机构",
  who6_1: "美国NFA监管，注册ID：0542569",
  who7: "全球人数",
  who8:
    "作为全球金融市场领先者之一，{platform}为我们的客户提供顶级和稳定的服务。",
  who9: "以下是{platform}的一些相关数据：",
  who10: "10年+",
  who11: "行业资历",
  who12: "1.5B万以上",
  who13: "每月交易量",
  who14: "7M以上",
  who15: "客户帐户",
  who16: "$1.5B",
  who17: "月交易量",
  why0: "为什么选择{platform}",
  why1: "不仅仅是一个平台，而是一位合作伙伴",
  why2:
    "“交易者在选择外汇经纪人时想要什么？” –这是我们创立{platform}时不断问自己的问题。相信这些要素是定义我们价值的核心，使我们能够满足客户的需求并持续提供卓越可靠的服务。",
  why3:
    "最重要的是，我们希望建立一个超越价格或产品而闻名的品牌。我们希望成为新世代交易的品牌。熟知客户的需求，让我们可以更灵活地进行变更。我们是高效能的新世代交易平台，在您需要时{platform}总是在您身边。",
  why4: "交易旅程中，我们就在您身边",
  why5:
    "无论您是刚起步的新手或是交易多年的老手，我们的团队随时都会为您提供支援。我们的平台随时随地与您同在，我们的客户服务团队陪伴您迈出的每一步，我们将陪伴您一起成长。尽管我们的竞争对手可能比我们更强大，但我们有创新动力，以及合规交易平台的支持。了解为什么{platform}是您正确的选择：",
  why6: "5分钟立即开通真实帐户",
  why7: "杠杆高达500：1",
  why8: "可交易200种以上的商品",
  why9: "提供额外的交易赠金",
  why10: "强大的客户端管理系统",
  why11: "绝佳的市场流动性",
  why12: "多个监管机构和分离账户作为担保",
  trading1: "使用Metatrader5平台",
  trading2: "随时随地进行交易",
  trading3:
    "若您是{platform}的新客户，只需填写此页面顶部的表格，就可以在几分种之内使用MT5交易平台。",
  trading4:
    "如果您已经是在MT5平台上进行交易的{platform}客户，只需要登录您的客户管理后台，点击打开账户并选择MetaTrader5，即可无缝切换至MT5，进一步提升您的交易体验。",
  trading5: "MT5移动App让您随时随地的连接到{platform}，享受全天候的交易服务。",
  guide0: "MT5指南",
  guide1: "在您的电脑下载MT5",
  guide3: "如何插入图表名额？",
  guide3_0: "按以下步骤进行操作：",
  guide3_1: "1）在顶端功能表列上，选择插入名额。",
  guide3_2: "2）您也可以从导航部分插入名额。",
  guide4: "如何规避防火墙保护？",
  guide4_1:
    "禁止您的反病毒防火墙申请MetaTrader 4，打开1950埠。申请MetaTrader 5的则打开443埠。",
  guide5: "我如何创建趋势线和其他线的研究？",
  guide5_1: "1）在顶端功能表列上，选择“插入”",
  guide5_2: "2）选择想要的趋势线。",
  guide5_3:
    "3）释放滑鼠按钮后，将出现带有十字准线的选中趋势线的影像图标。使用滑鼠把十字准线放在选中的图表上。点击滑鼠，按住不放进行移动滑鼠来调整趋势线的大小。",
  guide5_4:
    "线研究的快捷方式也可通过点击“浏览”工具列线研究快速访问，让图标刚好在功能表列下显现。",
  guide5_5:
    "您也可以选择出现在荧幕顶端的其他选项。包括点击趋势线、十字准线、斐波纳契回档线等。",
  guide6: "如何显示条形图？",
  guide6_1: "在顶端的功能表列中，选择“图表条形图”或使用键盘快捷方式（Alt+1）",
  guide7: "如何获取帐户资讯和Metatrader平台的日常交易？",
  guide7_1:
    "请使用平台的终端（TERMINAL）部分。如果您不打开这个部分，可以通过浏览终端TERMINAL或使用键盘快捷方式Cntrl+t。",
  guide7_2: "在终端部分，选择“帐户历史标记”。",
  guide7_3: "这一标记向您显示了帐户的历史，为方便起见也可进行列印。",
  guide7_4: "在本部分任何地方点击滑鼠右键。",
  guide7_5:
    "选择“以报告保存”。 （也可以以HTML档案保存，这种档案可以转换为Excel档案留作记录。）",
  guide8: "如何显示烛柱图？",
  guide8_1: "在顶端的功能表列上，选择“图表烛柱图”或使用键盘快捷方式（Alt+2）。",
  guide9:
    "我可以在你们的系统上使用MetaTrader应用程序介面吗？这可以先在迷你/类比帐户上进行吗？",
  guide9_1:
    "可以，只要您希望，就可以首先使用类比帐户进行。通常，特定的条款和条件适用于应用程序介面对真实系统的访问。请确保您与FXDD代表探讨了您的项目，这样一来，他们就可以向您提供帮助。",
  guide10: "如何显示线图？",
  guide10_1: "在顶端的功能表列上，选择“图表线图”或使用键盘快捷方式（Alt+3）。",
  guide11: "怎样拉近或拉远图表？",
  guide11_1: "1）确保“图表”工具列已经启用",
  guide11_2: "2）接下来，选择在功能表列下定位的合理行动的图标，即‘+’and‘-‘.",
  guide11_3: "3）选择两个图标中的一个拉近或拉远图标。",
  guide11_4: "或者，对此功能使用键盘快捷方式。拉近为（Shift +），拉远为（-）。",
  guide12: "MetaTrader平台有助于迷你手（10K）的交易吗？",
  guide12_1: "是的，您可以使用MetaTrader平台进行迷你手（10K）的交易。",
  guide12_2: "以下是我们在Metatrader上用于交易手数大小的范围：",
  guide12_3: "0.01手=1000组织的基准货币（或美元）我们的“超迷你”手。",
  guide12_4: "0.10手=10000组织基准货币（或美元）我们的“迷你”手。",
  guide12_5: "1.00手=100000组织基准货币（或美元）我们的“标准”手。",
  guide13: "我已经下载了平台。如何登入到我的真实帐户中进行交易呢？",
  guide13_1:
    "用户应已收到帐户准予的电子邮件通知，通知上注明了登录名和密码（即登录名为“81234”，密码为“xxxxx”）。这就是您的真实帐户的帐户资讯。如果您下载了平台，打开登入屏。注意，这时打开的荧幕会要求您开设一个帐户。您可以点击“X”退出此屏。",
  guide13_2: "登入时，选择“档案登入”，键入您的登录名和密码。",
  guide13_3:
    "服务器栏位拥有一个下拉式菜单，选择以下服务器：‘FXDD-MT5 Live Server 2 - FXDD’。",
  guide13_4: "注意听“叮”的声音（确认音），您的帐号将在平台的左上角显现。",
  guide13_5:
    "如果您看见价格在Market Watch中移动，且终端部分显示正确的余额时，标明您已成功登入到您的真实帐户。如果您在登入时遇到问题，请发送电子邮件至support@leedword.com。",
  guide14: "我如何在MetaTrader上修改密码？",
  guide14_1: "在顶端的功能表列上，选择“工具选项”或键盘快捷方式（Ctrl+O）。",
  guide14_2: "在“服务器”图标下，选择“修改”。",
  guide14_3: "在“当前密码”文字栏位中输入当前密码。",
  guide14_4: "在“修改主密码”那里打勾。",
  guide14_5: "在“新密码”文字栏位中输入新密码。",
  guide14_6: "在第二个“确认”文字栏位中重新键入新密码。",
  guide15: "怎样选择使用语言？",
  guide15_1:
    "在顶端功能表列上，选择“浏览语言”，选择您偏好的语言。然后关闭平台重开程式即可。",
  guide16: "要在平台上显示不同的视窗，可以使用哪些键盘快捷方式？",
  guide16_1: "最常使用的键盘快捷方式有：",
  guide16_2: "Ctrl+M=市价观察视窗",
  guide16_3: "Ctrl+N=导航视窗",
  guide16_4: "Ctrl+T=终端视窗",
  guide17: "我如何查看FXDD提供的所有货币对？",
  guide17_1:
    "在Market Watch视窗中，右击并选择“显示全部”，就可以查看可以进行交易的所有货币对了。所有的货币对随即便可显现。",
  guide18: "我如何在Market Watch视窗中显示高/低价？",
  guide18_1: "在Market Watch视窗中，按照以下步骤显示高/低价格：",
  guide18_2: "在Market Watch视窗中右击（任何部分）",
  guide18_3: "选择“高”/“低”。 （这时将出现当日各货币对的高低价格。）",
  guide19: "你们可以引导建立图表吗？有哪些选择？",
  guide19_1:
    "可以，MetaTrader 5平台是市场上最先进的平台之一，其中的制图选项和包尤其如此。",
  guide19_2:
    "使用帮助选单（按F1）下的“帮助主题”选项，标记“与图表开始工作”部分。这部分应作为一个良好起步的开始。",
  guide19_3:
    "您可以变更图表的整体外观（“功能表列”—“图表”—“内容”）。您可以变更背景、前景、表格等的颜色。您可以滚动图表视窗的边缘调整图表大小，下拉滑鼠按钮调整大小。",
  guide20: "如何修改MetaTrader图表的显示时间周期？",
  guide20_1:
    "对主菜单栏添加时限时，选择“浏览工具列”。 “周期”（如果需要）。使用以下图例将时限用于图表中：",
  guide20_2: "M1=1分钟的图表",
  guide20_3: "M5=5分钟的图表",
  guide20_4: "M15=15分钟的图表",
  guide20_5: "M30=30分钟的图表",
  guide20_6: "H1=1小时的图表",
  guide20_7: "H4=4小时的图表",
  guide20_8: "D1=每日图表",
  guide20_9: "W1=每周图表",
  guide20_10: "MN=每月图表",
  guide21: "MetaTrader 5有使用者指南吗？",
  guide21_1:
    "有的，在平台选择“帮助帮助主题”或者您可以点击这里进行下载。请注意，我们设有线上研讨会，可以帮助您了解这一平台的功能。如果您想参加这些线上研讨会，请发送电子邮件至销售部。",
  guide22: "Metatrader平台上的时区是什么？这一时间可以进行调整吗？",
  guide22_1:
    "夏令时，客户在MetaTrader上的时间为GMT+3（格林尼治标准时间加上3小时，北京时间加5小时）。很遗憾的是，MetaTrader平台上的时间无法变更。对此造成的任何不便，我们深感抱歉。",
  guide23: "如何在MetaTrader平台上再开设一个类比帐户？",
  guide23_1: "在平台中选择“档案开设一个帐户”",
  guide23_2: "填写要求的资讯（务必要在“我同意订阅你们的简讯”栏中打勾）",
  guide23_3: "选择“下一步”（在服务器页上）",
  guide23_4: "选择“下一步”（请注意，您的用户名和密码将会显现）",
  guide23_5: "选择“完成”",
  guide23_6: "这一软件将会让您自动登录到您新的类比帐户，在导航视窗查看。",
  guide24: "影响程式中往来通信量的因素是什么？",
  guide24_1:
    "输出的通信量取决于用户的活动，数量相当少。输入的通信量直接取决于打开的图表视窗的数量。",
  guide25: "我可以通过电子邮件接收警告吗？",
  guide25_1: "遵循以下步骤在MetaTrader 5中创建电子邮件警告：",
  guide25_2:
    "（所有简单邮件传送协议（SMTP）的设定因互联网服务供应商而各不相同。如果您收到错误资讯，联系您的互联网服务供应商的技术支援，请求他们进行简单邮件传送协议的设定。如果您使用Outlook，可以选择“工具电子邮件帐户下一步修改”完成时取消）进行简单邮件传送协议的设定。",
  guide25_3: "选择“工具选项”。",
  guide25_4: "选择”电子邮件”图标。",
  guide25_5:
    "根据您的互联网服务供应商的要求编辑上述设定。通常，淡红色文字是您应该登入的一般准则。具体说明请联系您的互联网服务供应商。 （注意：无法使用的网络电子邮件服务有Hotmail，Yahoo，Gmail等）",
  guide25_6: "简单邮件传送协议服务器-这是您的互联网服务供应商的邮件伺服器地址",
  contact1: "当您需要我们时，我们总是在您身边",
  contact2:
    "如果您有任何疑问或需要更多协助，请通过以下联系方式与我们联系。我们将尽力尽快答复所有问题。",
  contact3: "注册地址",
  contact4: "开曼办事处",
  contact5: "办事处",
  contact6: "台湾台北信义区五段7号(台北101)",
  contact7: "电子邮件地址",
  contact8: "联系电话",
  address1: "澳大利亚，悉尼",
  address2: "台北",
  address3: "泰国，曼谷",
  address4: "马来西亚，吉隆坡",
  address5: "英国，伦敦",
  address6: "美国，纽约",
  address7: "新加坡，新加坡市",
  address8: "开曼群岛，乔治城",
  address9: "塞浦路斯，尼科西亚",
  address10: "香港",
  address11: "越南，河内",
  address12: "澳大利亚，墨尔本"
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js